<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [id]="controlId"
    [errorMsg]="internalError$ | async"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-tag-list-complex-base
            [indeterminateMsg]="indeterminateMsg"
            [autocomplete]="autocomplete"
            [formControl]="control"
            [id]="controlId"
            [placeholder]="placeholder"
            [errorMsg]="errorMsg"
            [sanitizeFct]="sanitizeFct"
            [autocompleteFct]="autocompleteFct"
            [duplicateErrorMsg]="duplicateErrorMsg"
            [invalid]="isControlInvalid$ | async"
            [styling]="styling"
            [actionItem]="actionItem"
            [singleTag]="singleTag"
            [caseSensitive]="caseSensitive"
            [isDisabled]="control.disabled"
            [maxLength]="maxLength"
            (duplicateValues)="emitDuplicates($event)"
            (internalError)="onInternalError($event)"
        >
        </sh-form-tag-list-complex-base>
    </ng-template>
    <ng-template #simple>
        <sh-form-tag-list-base
            [formControl]="control"
            [id]="controlId"
            [autocomplete]="autocomplete"
            [placeholder]="placeholder"
            [errorMsg]="errorMsg"
            [sanitizeFct]="sanitizeFct"
            [autocompleteFct]="autocompleteFct"
            [duplicateErrorMsg]="duplicateErrorMsg"
            [invalid]="isControlInvalid$ | async"
            [styling]="styling"
            [actionItem]="actionItem"
            [singleTag]="singleTag"
            [caseSensitive]="caseSensitive"
            [isDisabled]="control.disabled"
            [maxLength]="maxLength"
            (duplicateValues)="emitDuplicates($event)"
            (internalError)="onInternalError($event)"
        >
        </sh-form-tag-list-base>
    </ng-template>
</sh-form-group>
